
import React from "react";
import { Loader2, Upload } from "lucide-react";

interface LogoUploaderProps {
  isUploading: boolean;
  onFileUpload: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const LogoUploader: React.FC<LogoUploaderProps> = ({
  isUploading,
  onFileUpload,
}) => {
  return (
    <div className="my-4">
      <div className="text-sm text-white/70 mb-2">Upload New Logo</div>
      <label className="flex items-center justify-center p-4 border border-dashed border-white/20 rounded-md cursor-pointer hover:bg-white/5 transition-colors">
        <input
          type="file"
          accept="image/*"
          className="hidden"
          onChange={onFileUpload}
          disabled={isUploading}
        />
        {isUploading ? (
          <Loader2 className="h-5 w-5 animate-spin text-white/70 mr-2" />
        ) : (
          <Upload className="h-5 w-5 text-white/70 mr-2" />
        )}
        <span className="text-sm text-white/70">
          {isUploading ? "Uploading..." : "Click to upload a logo"}
        </span>
      </label>
    </div>
  );
};
